import { FlexSpinner } from 'common'

import usePublicProfile from './use-public-profile'
import Profile from './profile'
import Contributions from './contributions'

type PublicProfileProps = {
  userId: number
}

export default function PublicProfile(props: PublicProfileProps) {
  const { loading, user } = usePublicProfile(props.userId)

  if (loading) {
    return <FlexSpinner />
  }

  return (
    <div className="container mx-auto max-w-3xl py-16 px-8 sm:px-16 lg:px-0">
      <Profile className="mb-12" userRef={user} />
      <Contributions userRef={user} />
    </div>
  )
}
